import { useFormContext, type FieldPath, type FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { CardEtapaInicial } from '@/features/proposta/components/card-etapa-inicial'
import { VagaPadraoTrigger } from '@/features/proposta/components/vaga-padrao/vaga-padrao-trigger'
import type { TVagasSelecionadas } from '@/features/proposta/interfaces/proposta.type'
import { StringUtils } from '@/utils'

const getVagaPadraoVariant = (completed: boolean, optional?: boolean) => {
  let vagaPadraoVariant: 'completed' | 'default' | 'optional' = 'default'
  if (!completed && optional) vagaPadraoVariant = 'optional'
  if (completed) vagaPadraoVariant = 'completed'
  return vagaPadraoVariant
}

export const CardVagaPadrao = <TFieldValues extends FieldValues = FieldValues>() => {
  const { t } = useTranslation('proposta')
  const { watch } = useFormContext<TFieldValues>()

  const vagasSelecionadas = watch('informacoesIniciais.vagaIds' as FieldPath<TFieldValues>) as TVagasSelecionadas

  const acessorioNaoObrigatorioNaUnidade = !watch(
    'informacoesIniciais.simulacaoUnidade.produto.acessorioObrigatorio' as FieldPath<TFieldValues>,
  )
  const naoPossuiAcessorioExtraNaProposta = !watch(
    'informacoesIniciais.simulacoesAcessorios' as FieldPath<TFieldValues>,
  ).length

  const vagaPadraoVariant = getVagaPadraoVariant(
    !!vagasSelecionadas.length,
    acessorioNaoObrigatorioNaUnidade && naoPossuiAcessorioExtraNaProposta,
  )
  const completed = vagaPadraoVariant === 'completed'
  const vagaDeTrocaSelecionada = vagasSelecionadas.some((vaga) => vaga.substituiVagaPadrao)

  return (
    <CardEtapaInicial variant={vagaPadraoVariant}>
      <CardEtapaInicial.Content
        label={t('informacoes_iniciais.cards.vaga_padrao.titulo')}
        description={t('informacoes_iniciais.cards.vaga_padrao.vincule')}
      >
        {completed && (
          <p className="grid grid-cols-[16px_1fr] gap-1 text-xs text-green-800">
            <Icon name="check" className="h-4 w-4" />
            {vagaDeTrocaSelecionada ? (
              <span className="text-nunito tracking-wide text-wrap">
                {t('informacoes_iniciais.cards.vaga_padrao.trigger.trocar_vaga')}
              </span>
            ) : (
              <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                {StringUtils.singularPlural(
                  vagasSelecionadas.length,
                  t('informacoes_iniciais.cards.vaga_padrao.vinculada'),
                  t('informacoes_iniciais.cards.vaga_padrao.vinculadas'),
                )}
                {vagasSelecionadas.map((v) => v.descricao).join(', ')}
              </span>
            )}
          </p>
        )}
      </CardEtapaInicial.Content>
      <CardEtapaInicial.Action>
        <VagaPadraoTrigger />
      </CardEtapaInicial.Action>
    </CardEtapaInicial>
  )
}
